import axios from '../api/index'
export const getImages = async (folder) =>{
    const fetchImages = await axios.request('get','/images/' + folder)
    return fetchImages.data
}